export function formatBuyerIncentive(buyerIncentive: string | string[]) {
    if (buyerIncentive) {
        return 'Help to buy';
    }

    return '';
}
